import React, {Component} from 'react';
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {TableRow, TableCell} from "@amzn/meridian/table";
import Currency from "../common/currency";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import DateFilter from "../common/dateFilter";
import {getDriverReconciliationInBatch, getDrivers} from "./network/driverReconciliationAPI";
import Moment from "moment";
import {getStationCode} from "../../network/NetworkUtil";
import DriverReconciliationFilter from "./driverReconciliationFilter";
import AppLoader from "../common/appLoader";
import AppNotification from "../common/appNotification";
import DriverNameFilter from "./DriverNameFilter";
import RunningBalanceModal from "../modal/driverReconciliation/runningBalanceModal";
import DriverShipmentListDetailsModal from "../modal/driverReconciliation/driverShipmentListDetailsModal";
import PendingReconModal from "../modal/driverReconciliation/pendingReconModal";

class DriverReconciliation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stationCode: "",
            driverReconciliationList: [],
            driverList: [],
            driverReconciliationFilteredList: [],
            filters: {
                showFilter: true,
                date: Moment().format('YYYY-MM-DD'),
                driverName: ""
            },
            hasError: false,
            isLoading: true,
            errorMessage: "",
            openRunningBalanceModal: false,
            driverDetail: {},
            openDriverShipmentsModal:false,
            openPendingReconModal:false
        };

        this.onDriverNameChange = this.onDriverNameChange.bind(this);
        this.toggleOptionFilter = this.toggleOptionFilter.bind(this);
        this.onDateUpdate = this.onDateUpdate.bind(this);
        this.openRunningBalanceModal = this.openRunningBalanceModal.bind(this);
        this.openDriverShipmentsModal = this.openDriverShipmentsModal.bind(this);
        this.openPendingReconModal = this.openPendingReconModal.bind(this);
    }



    openRunningBalanceModal = driverReconciliation => {

        const {driverList} = this.state;
        const finalDriverReconciliation = {...driverReconciliation};

        let driverDetail = null;

        const id = driverReconciliation.driverInfo.id;

        if (driverReconciliation.store) {
            driverDetail = driverList.find(({driverName}) => driverName.includes(id)) ||
                driverList.find(({driverName}) => driverName === driverReconciliation.driverInfo.name);
        }
        else {
            driverDetail = driverList.find(({tasId}) => tasId === id);
        }

        if (driverDetail) {
            finalDriverReconciliation.compEmployeeId = driverDetail.employeeId;
            finalDriverReconciliation.date = this.state.filters.date;
        }

        this.setState({
            openRunningBalanceModal: true,
            driverDetail: finalDriverReconciliation
        })

    }

    closeRunningBalanceModal = () => {
        this.setState({
            openRunningBalanceModal: false,
        })

    }

    openDriverShipmentsModal = driverReconciliation => {

        const {driverList} = this.state;
        const finalDriverReconciliation = {...driverReconciliation};

        let driverDetail = null;

        const id = driverReconciliation.driverInfo.id;

        if (driverReconciliation.store) {
            driverDetail = driverList.find(({driverName}) => driverName.includes(id)) ||
                driverList.find(({driverName}) => driverName === driverReconciliation.driverInfo.name);
        }
        else {
            driverDetail = driverList.find(({tasId}) => tasId === id);
        }

        if (driverDetail) {
            finalDriverReconciliation.compEmployeeId = driverDetail.employeeId;
            finalDriverReconciliation.date = this.state.filters.date
            finalDriverReconciliation.stationCode = this.state.stationCode
        }

        this.setState({
            openDriverShipmentsModal: true,
            driverDetail: finalDriverReconciliation
        })

    }

    closeDriverShipmentsModal = () => {
        this.setState({
            openDriverShipmentsModal: false,
        })

    }
    openPendingReconModal = driverReconciliation => {

        const {driverList} = this.state;
        const finalDriverReconciliation = {...driverReconciliation};

        const driverDetail = driverList.find(({tasId}) => tasId === driverReconciliation.driverInfo.id);

        if (driverDetail) {
            finalDriverReconciliation.compEmployeeId = driverDetail.employeeId;
            finalDriverReconciliation.date = this.state.filters.date;
        }

        this.setState({
            openPendingReconModal: true,
            driverDetail: finalDriverReconciliation
        })

    }

    closePendingReconModal = () => {
        this.setState({
            openPendingReconModal: false,
        })

    }

    fetchDriverReconciliation() {
        this.setState({isLoading: true}, () => {
            getDriverReconciliationInBatch({
                stationCode: this.state.stationCode,
                date: this.state.filters.date,
                driverList: this.state.driverList,
                filters: this.state.filters
            }).then(result => {
                this.setState({...result, isLoading: false}, () => {
                    this.filterData()
                });
            });
        });

    }

    componentDidMount() {
        const stationCode = getStationCode();
        this.setState({stationCode: stationCode, isLoading: true});

        getDrivers(stationCode).then(result => {
                this.setState({...result, isLoading: false}, () => {
                });
            }
        );
    }

    toggleOptionFilter() {
        return this.setState(state => (state.filters.showFilter = !state.filters.showFilter));
    }

    onDriverNameChange(selectedOption) {
        this.setState(state => (state.filters.driverName = selectedOption), () => {
            this.fetchDriverReconciliation();
            this.filterData();
        });
    }

    onDateUpdate(selectedDate) {
        this.setState(state => (state.filters.date = selectedDate), () => {
            this.fetchDriverReconciliation();
            this.filterData();
        });
    }

    filterData() {
        const {filters} = this.state;
        const filteredDriverList = this.state.driverReconciliationList.filter(driverReconciliation => {
            let expectedDriverName = filters.driverName.split("/")[0].trim();
            let actualDriverName = ((driverReconciliation.driverInfo || {}).name || "").split("/")[0].trim();
            return filters.driverName === "" ? true : expectedDriverName === actualDriverName;
        });
        this.setState({driverReconciliationFilteredList: filteredDriverList});
    }

    render() {
        const {driverReconciliationFilteredList = [], driverList = [], filters} = this.state;

        return (
            /*Main Column*/
            <Column>
                <Row>
                    {this.state.hasError && <AppNotification type="error" message={this.state.errorMessage}/>}
                </Row>
                <DriverReconciliationFilter filters={this.state.filters} onToggle={this.toggleOptionFilter}/>

                {/* Second Row*/}
                {filters.showFilter ?
                    this.state.isLoading ?<AppLoader/> :
                <Row backgroundColor="secondary" spacingInset="medium large large"
                         widths={["grid-2", "grid-2", "grid-2"]}>
                        <Box>
                            <Text type="h100">Date</Text>
                            <DateFilter initialDate={this.state.filters.date} onChangeDate={this.onDateUpdate}/>
                        </Box>
                        <Box>
                            <DriverNameFilter
                                data={driverList}
                                onChange={event => this.onDriverNameChange(event)}
                                placeholder="Select Driver"/>
                        </Box>
                    </Row> : null}

                {this.state.isLoading ? <AppLoader/> :
                        this.state.driverReconciliationFilteredList.length > 0 ?
                    <Row spacingInset="medium medium large" widths={[" grid-11"]}>
                        <Table headerRows={2}>
                            <TableRow>
                                <TableCell columnSpan={2} >Driver</TableCell>
                                <TableCell columnSpan={2} >Provider</TableCell>
                                <TableCell columnSpan={4} >Daily Payment</TableCell>
                                <TableCell columnSpan={2} >Overall Payment</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Expected</TableCell>
                                <TableCell>Undebriefed  MPOS  </TableCell>
                                <TableCell>Undebriefed  CASH  </TableCell>
                                <TableCell>Variance</TableCell>
                                <TableCell>Running Balance</TableCell>
                                <TableCell>Pending Recon</TableCell>
                            </TableRow>

                            {driverReconciliationFilteredList.map(function (driverReconciliation, index) {
                                const {driverInfo, paymentInfo, providerInfo} = driverReconciliation;
                                return <TableRow key={index}>

                                    <TableCell>
                                        <span
                                            onClick={this.openDriverShipmentsModal.bind(this, driverReconciliation)}
                                            style={{cursor: "pointer", textDecoration: "underline"}}>
                                            {(driverInfo || {}).name}
                                        </span>
                                    </TableCell>
                                    <TableCell>{(driverInfo || {}).id}</TableCell>

                                    <TableCell>{(providerInfo || {}).name}</TableCell>
                                    <TableCell>{(providerInfo || {}).type}</TableCell>

                                    <TableCell><Currency amount={paymentInfo.expected}/></TableCell>
                                    <TableCell><Currency amount={paymentInfo.actualMpos}/></TableCell>
                                    <TableCell><Currency amount={paymentInfo.actualCash}/></TableCell>
                                    <TableCell><Currency amount={paymentInfo.variance} isVariance={true}/></TableCell>

                                    <TableCell>
                                        <span
                                            onClick={this.openRunningBalanceModal.bind(this, driverReconciliation)}
                                            style={{cursor: "pointer", textDecoration: "underline"}}>
                                            <Currency amount={paymentInfo.balance} isVariance={true}/>
                                        </span>
                                    </TableCell>

                                    <TableCell>
                                        <span
                                            onClick={this.openPendingReconModal.bind(this, driverReconciliation)}
                                            style={{cursor: "pointer", textDecoration: "underline"}}>
                                            <Currency amount={paymentInfo.overallPendingRecon} isVariance={true}/>
                                        </span>
                                    </TableCell>

                                </TableRow>
                            }.bind(this))}

                            <RunningBalanceModal
                                value={this.state.openRunningBalanceModal}
                                onClose={this.closeRunningBalanceModal}
                                runningBalanceModalData={this.state.driverDetail}
                            />

                            <DriverShipmentListDetailsModal
                                value={this.state.openDriverShipmentsModal}
                                onClose={this.closeDriverShipmentsModal}
                                driverShipmentListDetailsModalData={this.state.driverDetail}
                            />

                            <PendingReconModal
                                value={this.state.openPendingReconModal}
                                onClose={this.closePendingReconModal}
                                pendingReconModalData={this.state.driverDetail}
                            />

                        </Table>
                    </Row> :
                    this.state.filters.driverName ?
                    <Row spacingInset="medium large large"
                        widths={["grid-2", "grid-2", "grid-2"]}>
                    <Box> <Text>No results found</Text> </Box>
                    </Row>
                    :null
                }
            </Column>
        );
    }
}

export default DriverReconciliation;


// WEBPACK FOOTER //
// ./src/component/driverReconciliation/driverReconciliation.js